<template>
  <div class="has-partner-component">
    <div class="column is-8 is-offset-2">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 has-text-centered has-text-grey-dark dm-sans">
            Selecione qual a rede parceira
          </p>
        </div>
      </div>
      <div class="columns mt-4">
        <div class="column is-full is-flex is-justify-content-center is-align-content-center">
          <div class="select is-large is-primary is-one-quarter">
            <select class="has-text-centered" v-model="formData.partner.data">
              <option disabled selected>Selecionar</option>
              <option :value="partner" v-for="(partner, index) in partners" :key="index">
                {{ partner.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6" v-if="formData.partner.data && formData.partner.data.id">
      <next-button
          @nextTab="$emit('nextTab')"
          position="right"
          sizeClass="is-one-third"
      ></next-button>
    </div>
  </div>
</template>

<script>

import partners from '@/apis/partners'
import NextButton from './NextButton'

export default {

  name: 'partners',

  data() {
    return {
      partners: []
    }
  },

  components: {
    NextButton
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  async mounted() {
    this.partners = await partners.get()

    for (const partner of this.partners) {
      console.log(this.formData.company.data.network_id)
      console.log(partner.external_id)
      if (partner.external_id == this.formData.company.data.network_id) {
        this.formData.partner.data = partner
        this.$emit('nextTab')
        break
      }
    }
  },

  methods: {
    selectNoPartner() {
      this.formData.partner.data = {}
      this.$emit('nextTab')
    }
  }

}

</script>
